define('Search/Search',["instantsearch", "eventManager", "score_ccf/Events/ModulesLoadedEvent", "Track/Events", "Utility/ErrorHandler"],
    function (instantsearch, eventManager, modulesLoadedEvent, events, errorHandler) {
        'use strict';

        // this is intended to be a singleton. many search components need to pull and configure the same instance. 
        // whichever component comes first, others will just reuse the configured instantsearch

        var instance = null;

        function Search() {
            if (instance !== null) {
                errorHandler.logError("Cannot instantiate more than one Search, use Search.getInstance()");                
            }

            this.initialize();
        }

        Search.prototype = {
            initialize: function () {
                this.search = {};
                this.configured = false;
            }
        };

        Search.getInstance = function () {
            // Gets an instance of the singleton
            if (instance === null) {
                instance = new Search();
            }
            return instance;
        };

        Search.prototype.configure = function configure(options) {
            Search.getInstance().search = instantsearch(options);
            this.configured = true;
            eventManager.trigger("AlgoliaConfiguredEvent");

            Search.getInstance().search.on('render', function () {
                eventManager.trigger(events.global.algoliaRendered, this);
            });
        }

        // some magic here... we can only add widgets if instantsearch has been initialized, so we abuse the eventmanager to track that
        Search.prototype.addWidget = function addWidget(options) {
            if (!this.configured) {
                eventManager.subscribe("AlgoliaConfiguredEvent",
                    function () {
                        Search.getInstance().search.addWidget(options);
                    });
            } else {
                Search.getInstance().search.addWidget(options);
            }
        }

        eventManager.subscribe(modulesLoadedEvent.name, function () {
            if (Search.getInstance().configured) {
                Search.getInstance().search.start();
            }
        });

        Search.prototype.defaultConfig = function defaultConfig(algoliaApplicationId, algoliaApiKey, algoliaIndexName, contextLanguage) {
			this.configure({
                appId: algoliaApplicationId,
                apiKey: algoliaApiKey,
                indexName: algoliaIndexName,
                urlSync: true,
                searchParameters: {
                    facetsRefinements: {
                        _language: [contextLanguage]
                    }
                },
                facets: ["_language"]
            });                       
        }

        return Search.getInstance();
    });
